import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

export interface TabItem {
  id: string;
  label: string;
  disabled?: boolean;
  icon?: string;
  badge?: string | number;
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'genxapp-planilla';
  activeTab: string = 'Conductor';

  handleCardClick(): void {
    console.log('Card clicked!');
  }

  showTabActive(tabId: string): void {
    this.activeTab = tabId;
    console.log('Active Tab:', tabId);
  }

  // Example tabs data
  exampleTabs: TabItem[] = [
    { id: 'Conductor', label: 'Conductor', icon: 'icon' },
    { id: 'Despachador', label: 'Despachador', icon: 'icon' },
  ];

  // Upload Images handlers
  onImagesSave(images: any[]): void {
    console.log('Saving images:', images);
  }

  onImagesCancel(): void {
    console.log('Upload cancelled');
  }

  onImagesError(error: string): void {
    console.error('Upload error:', error);
  }
}
